define('app/factories/product_sub_category_single_page_factory',['app/setup','app/views/product_sub_category_single_page_view','app/collections/product_sub_category_single_page_products'],
  function(takhfifan,productSubCategorySinglePageView,productSubCategorySinglePageProducts) {
    $('.tkh-sub-special-category-single').each(function(){
      new takhfifan.ProductSubCategorySinglePageView({
        el: $(this),
        collection: new takhfifan.ProductSubCategorySinglePageProducts()
      });
    });
});


